import angular from 'angular'

import AppError          from './error'
import AppMessage        from './app-message'
import AppSpinner        from './spinner'
import CookiesConsent    from './cookies-consent'
import DocumentConsent   from './document-consent'
import EmailLinkRedirect from './email-link-redirect'
import Filters           from './filters'
import Footer            from './footer'
import GoogleAnalytics   from './google-analytics'
import Header            from './header'
import HelpBlock         from './help-block'
import I18n              from './i18n'
import IframeRedirect    from './iframe-redirect'
import InputTooltip      from './input-tooltip'
import Interceptors      from './interceptors'
import Localization      from './localization'
import MyRenault         from './my-renault'
import Navbar            from './navbar'
import RlinkAppsStatus   from './rlink-apps-status'
import StoreTypes        from './store-types'
import Tooltip           from './tooltip'
import Validators        from './validators'

let module = angular.module('app.common', [
  AppError,
  AppMessage,
  AppSpinner,
  CookiesConsent,
  DocumentConsent,
  EmailLinkRedirect,
  Filters,
  GoogleAnalytics,
  Header,
  MyRenault,
  HelpBlock,
  I18n,
  IframeRedirect,
  InputTooltip,
  Interceptors,
  Localization,
  Navbar,
  RlinkAppsStatus,
  StoreTypes,
  Tooltip,
  Validators,
  Footer
])
.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/index.js